<template>
  <v-footer id="core-footer" height="72em" color="background">
    <v-container fluid no-gutters>
      <v-row align="center" justify="space-between" no-gutters>
        <v-col xs="12" sm="3" align="center">
          <v-card-text>
            <a href="/terms.html" target="_blank" class="text-caption">
              Terms and conditions
            </a>
          </v-card-text>
        </v-col>
        <v-col xs="12" sm="3" align="center">
          <v-card-text>
            <a
              href="https://www.iubenda.com/privacy-policy/53958737"
              target="_blank"
              class="text-caption"
            >
              Privacy policy
            </a>
          </v-card-text>
        </v-col>
        <v-col xs="12" sm="3" align="center">
          <v-card-text>
            <a
              href="https://www.iubenda.com/privacy-policy/53958737/cookie-policy"
              target="_blank"
              class="text-caption"
            >
              Cookie policy
            </a>
          </v-card-text>
        </v-col>
        <v-col xs="12" sm="3" align="center">
          <v-card-text>
            <span class="text-caption"> &copy; {{ new Date().getFullYear() }} </span>
            <a href="https://kiwifarm.it/" target="_blank" class="text-caption">
              Kiwifarm Srl
            </a>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    //
  }),

  computed: {
    //
  },
}
</script>

<style scoped>
/* #core-footer {
  background-color: var(--v-background);
} */
/* #core-footer {
  z-index: 0;
} */
</style>
